export default {
	ALL_MEETINGS: "ALL_MEETINGS",
	TEAM_MEETINGS: "TEAM_MEETINGS",
	ONE_ON_ONE_MEETINGS: "ONE_ON_ONE_MEETINGS",
	MEETINGS_WITH_NO_TOPICS: "MEETINGS_WITH_NO_TOPICS",
	MEETINGS_WITH_NO_TEAM: "MEETINGS_WITH_NO_TEAM",
};



// WEBPACK FOOTER //
// ./src/constants/Schedule/ScheduleFilterType.js